module.exports = __webpack_public_path__ + "static/media/400390_01.29ae167a.png";